import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import LoadingButton from "@material-ui/lab/LoadingButton/LoadingButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import NumberFormat from "react-number-format";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Chart from "./Chart";
import TableDense from "./TableDense";
import TableDenseAskBid from "./TableDenseAskBid";
import TableDenseCurrent from "./TableDenseCurrent";
import moment from "moment/moment";
import { toNumber } from "config/util";
// import TextFieldNumber from "../../modules/TextField/TextFieldNumber";
import TextFieldNumber from "../../modules/CustomInput/CustomInput";
import TextFieldNumber2 from "../../modules/TextField/TextFieldNumber2";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import socketIOClient from "socket.io-client";
import env from "../../stores/env";

let socket = null;

const ExchSimple = ({
  loading,
  maps,
  accounts,
  rates,
  rates_jpy,
  scc,
  wallets,
  dispatch_info,
  dispatch_danger,
  dispatch_get_markets_rates,
  dispatch_get_markets_ohlcs,
  dispatch_get_markets_ohlc,
  dispatch_get_markets_orders,
  dispatch_get_wallets,
  dispatch_post_markets_exchanges,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();
  const [active_pair, set_active_pair] = useState(Object.keys(maps.coin_pairs.display)[0]);
  // const [active_pair, set_active_pair] = useState("BTCSCP");

  const theme = useTheme();
  const primary = theme.palette.primary.main;

  const [amount_buy, set_amount_buy] = useState("");
  const [amount_sell, set_amount_sell] = useState("");
  const [price_buy, set_price_buy] = useState("");
  const [price_sell, set_price_sell] = useState("");
  const [trigger, set_trigger] = useState("");

  const [type, set_type] = useState(1440);
  const [limit, set_limit] = useState(100);

  const maps_type = {
    [`1 ${t("分")}`]: 1,
    [`5 ${t("分")}`]: 5,
    [`1 ${t("時間")}`]: 60,
    [`1 ${t("日")}`]: 1440,
  };

  const maps_limit = {
    [`100 ${t("件")}`]: 100,
    [`1000 ${t("件")}`]: 1000,
    [`10000 ${t("件")}`]: 10000,
  };

  useEffect(() => {
    socket = socketIOClient(env.REACT_APP_SOCKET_URL, {
      reconnection: true,
      rejectUnauthorized: false,
      // path: '/socket/markets'
    });

    socket.on("connect", () => {
      // alert("connect")
    });

    socket.on("markets", () => {
      dispatch_get_markets_ohlc(
        {
          symbol: active_pair,
          type,
        },
        (data) => {}
      );

      dispatch_get_markets_rates({}, (data) => {});
      dispatch_get_wallets({}, (data) => {});
    });

    socket.on("orders", () => {
      dispatch_get_markets_orders({ symbol: active_pair }, (data) => {});
      dispatch_get_wallets({}, (data) => {});
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    dispatch_get_markets_ohlcs(
      {
        symbol: Object.keys(maps.coin_pairs.display)[0],
        type,
        limit,
      },
      (data) => {}
    );

    dispatch_get_markets_orders({ symbol: Object.keys(maps.coin_pairs.display)[0] }, () => {});
  }, []);

  const reduce_get_markets_ohlcs = useSelector((state) => state.reduce_get_markets_ohlcs);

  const reduce_get_markets_orders = useSelector((state) => state.reduce_get_markets_orders);

  if (!rates) {
    return <></>;
  }

  const active_rate = rates[active_pair] ? Number(rates[active_pair].rate) : "";
  const active_price = rates[active_pair] ? rates[active_pair].price : "";
  const active_price_global_buy = rates[active_pair] ? rates[active_pair].price_global.buy : "";
  const active_price_global_sell = rates[active_pair] ? rates[active_pair].price_global.sell : "";

  const active_self = maps.coin_pairs.self[active_pair];
  const active_other = maps.coin_pairs.other[active_pair];

  const active_self_wallets_balance = wallets
    ? wallets[active_self]
      ? wallets[active_self].deposit.balance
      : ""
    : "";
  const active_other_wallets_balance = wallets
    ? wallets[active_other]
      ? wallets[active_other].deposit.balance
      : ""
    : "";

  const rate_dollar = rates_jpy
    ? rates_jpy[`${active_other}JPY`]
      ? rates_jpy["USDJPY"].price
        ? rates_jpy[`${active_other}JPY`].price / rates_jpy["USDJPY"].price
        : 0
      : 0
    : 0;

  const rate_yen = rates_jpy
    ? rates_jpy[`${active_other}JPY`]
      ? rates_jpy[`${active_other}JPY`].price
      : 0
    : 0;

  const numberFixed = (val) => {
    if (val.indexOf("e") != -1) {
      //strにhogeを含む場合の処理
      const sign = val.substr(val.indexOf("e") + 1, 1);
      if (sign == "-") {
        const e = val.substr(val.indexOf("e") + 2);
        return Number(val).toFixed(e);
      }
    }

    return val;
  };

  const maps_coin_pairs_display = maps.coin_pairs.display;
  // delete maps_coin_pairs_display["CHCBTC"];

  return (
    <div className="wrapper">
      <div className="main-panel">
        <nav className="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top ">
          <div className="container-fluid">
            <div className="navbar-wrapper">
              <a className="navbar-brand" href="javascript:void(0);">
                <i className="material-icons">account_balance</i>
                {t("かんたん売買")}
              </a>
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              aria-controls="navigation-index"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="navbar-toggler-icon icon-bar" />
              <span className="navbar-toggler-icon icon-bar" />
              <span className="navbar-toggler-icon icon-bar" />
            </button>
            <div className="collapse navbar-collapse justify-content-end">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a
                    href="settings.html"
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push({
                        pathname: `/settings`,
                      });
                      window.scroll(0, 0);
                    }}
                    style={{ textTransform: "none" }}
                  >
                    <i className="material-icons">account_circle</i>
                    {accounts.mail_address}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <div className="content">
          <div className="container-fluid">
            <div className="card">
              <div className="card-header card-header-dark d-none d-sm-block">
                <div className="nav-tabs-navigation">
                  <div className="nav-tabs-wrapper">
                    <ul className="nav nav-tabs nav-justified" data-tabs="tabs">
                      {Object.keys(maps_coin_pairs_display).map((k, idx) => {
                        const ary_rate = Number(rates[k].rate);
                        return (
                          <li className="nav-item" key={idx}>
                            <a
                              href="#"
                              className={`nav-link ${active_pair === k ? "active" : ""}`}
                              onClick={(e) => {
                                e.preventDefault();
                                set_active_pair(k);
                                set_amount_buy("");
                                set_amount_sell("");
                                set_price_buy("");
                                set_price_sell("");
                                dispatch_get_markets_ohlcs(
                                  {
                                    symbol: k,
                                    type,
                                    limit,
                                  },
                                  (data) => {}
                                );
                                dispatch_get_markets_orders({ symbol: k }, (data) => {});
                                socket.off("markets");
                                socket.off("orders");

                                socket.on("markets", () => {
                                  dispatch_get_markets_ohlc(
                                    {
                                      symbol: k,
                                      type,
                                    },
                                    (data) => {}
                                  );

                                  dispatch_get_markets_rates({}, (data) => {});
                                  dispatch_get_wallets({}, (data) => {});
                                });

                                socket.on("orders", () => {
                                  dispatch_get_markets_orders({ symbol: k }, (data) => {});
                                  dispatch_get_wallets({}, (data) => {});
                                });
                              }}
                            >
                              {/* {maps.coin_pairs.display[k]}
                              <p className="card-category">
                                <span
                                  className={
                                    ary_rate < 0 ? "text-warning" : "text-info"
                                  }
                                >
                                  {ary_rate < 0 ? "↓" : "↑"} {ary_rate}%
                                </span>
                              </p> */}
                              <div className="row">
                                <div className="col-4" style={{ padding: 0 }}>
                                  <img
                                    src={`coin_logo/${k}.png`}
                                    width={"100%"}
                                    alt="SC WORLD EXCHANGE"
                                  />
                                </div>
                                <div
                                  className="col-8"
                                  style={{
                                    display: "flex",
                                    justifyContent: "left",
                                    alignItems: "center",
                                    padding: 0,
                                  }}
                                >
                                  <div>
                                    {maps.coin_pairs.display[k]}
                                    <p className="card-category">
                                      <span className={ary_rate < 0 ? "text-warning" : "text-info"}>
                                        {ary_rate < 0 ? "↓" : "↑"} {ary_rate}%
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="card-body">
                <div className="">
                  <select
                    className="custom-select d-sm-none mb-3"
                    onChange={(e) => {
                      const pair = e.target.value;
                      set_active_pair(pair);
                      set_amount_buy("");
                      set_amount_sell("");
                      set_price_buy("");
                      set_price_sell("");
                      dispatch_get_markets_ohlcs(
                        {
                          symbol: pair,
                          type,
                          limit,
                        },
                        (data) => {}
                      );
                      dispatch_get_markets_orders({ symbol: pair }, (data) => {
                        // set_ohlcs(data.ohlcs);
                      });
                      socket.off("markets");
                      socket.off("orders");

                      socket.on("markets", () => {
                        dispatch_get_markets_ohlc(
                          {
                            symbol: pair,
                            type,
                          },
                          (data) => {}
                        );

                        dispatch_get_markets_rates({}, (data) => {});
                        dispatch_get_wallets({}, (data) => {});
                      });

                      socket.on("orders", () => {
                        dispatch_get_markets_orders({ symbol: pair }, (data) => {});
                        dispatch_get_wallets({}, (data) => {});
                      });
                    }}
                  >
                    {Object.keys(maps.coin_pairs.display).map((k, idx) => {
                      const ary_pair_display = maps.coin_pairs.display[k];
                      return (
                        <option key={idx} value={k}>
                          {ary_pair_display}
                        </option>
                      );
                    })}
                  </select>
                  {/* <h4 className="h4 card-title d-none d-sm-block">
                    {active_pair}
                  </h4> */}
                </div>
                <div className="row">
                  <div className="col-md-4 order-md-2 pr-0">
                    <div className="row">
                      {active_self === "SCC" && active_other === "SCP" ? (
                        <>
                          <div className="col-12">
                            <h2 className="display-4 card-title">
                              1<small>SCC</small>
                            </h2>
                            <h2 className="display-4 card-title">
                              <small>≈＄</small>
                              {toNumber(scc / rates_jpy.USDJPY.price, 4)}
                            </h2>
                            <h2 className="display-4 card-title">
                              <small>≈¥</small>
                              {scc}
                            </h2>
                            <span className={active_rate < 0 ? "text-warning" : "text-info"}>
                              <b>{active_rate < 0 ? "↓" : "↑"}</b>
                              {active_rate}%
                            </span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-12">
                            <h2 className="display-4 card-title">
                              {toNumber(active_price, maps.coin_decimals[active_other].price)}
                              <small>{active_other}</small>
                            </h2>
                            <h2 className="display-4 card-title">
                              <small>≈＄</small>
                              {active_price == 0 ? 0 : toNumber(active_price * rate_dollar, 5)}
                            </h2>
                            <h2 className="display-4 card-title">
                              <small>≈¥</small>
                              {active_price == 0 ? 0 : toNumber(active_price * rate_yen, 2)}
                            </h2>
                            <span className={active_rate < 0 ? "text-warning" : "text-info"}>
                              <b>{active_rate < 0 ? "↓" : "↑"}</b>
                              {active_rate}%
                            </span>
                          </div>
                        </>
                      )}
                      {reduce_get_markets_orders.askbid ? (
                        <>
                          <div className="col-12 d-none d-md-block">
                            <TableDenseAskBid
                              rows={reduce_get_markets_orders.askbid}
                              scc={scc}
                              set_price={(val) => {
                                // const str = numberFixed(val);
                                const str = toNumber(val, maps.coin_decimals[active_self].price);

                                set_price_buy(str);
                                set_price_sell(str);
                              }}
                              accounts={accounts}
                              active_self={active_self}
                              active_other={active_other}
                              active_pair={active_pair}
                              active_price={active_price}
                              rate_dollar={rate_dollar}
                              rate_yen={rate_yen}
                              other_price={maps.coin_decimals[active_other].price}
                              active_rate={active_rate}
                            />
                          </div>
                          <div className="col-12 d-none d-md-block">
                            <TableDense
                              loading={reduce_get_markets_orders.isLoading}
                              rows={reduce_get_markets_orders.orders}
                              set_price={(val) => {
                                const str = toNumber(val, maps.coin_decimals[active_self].price);
                                set_price_buy(str);
                                set_price_sell(str);
                              }}
                              accounts={accounts}
                              active_other={active_other}
                              active_self={active_self}
                            />
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-8 order-md-2">
                    <div className="row">
                      <div className="col-md-6 order-md-2">
                        {/* {!(active_self === "SCC" && active_other === "SCP") && (
                          <> */}
                        {false && (
                          <TextFieldNumber
                            fullWidth={true}
                            value={price_buy}
                            set_value={set_price_buy}
                            labelText={t("指値")}
                            endAdornment={active_other}
                            decimalScale={maps.coin_decimals[active_pair].price}
                          />
                        )}
                        <TextFieldNumber
                          fullWidth={true}
                          value={amount_buy}
                          set_value={set_amount_buy}
                          labelText={t("数量")}
                          endAdornment={active_self}
                          decimalScale={maps.coin_decimals[active_pair].amount}
                        />
                        <dl className="row small">
                          <dt className="col-5">
                            {t("利用可能")} {active_other}
                          </dt>
                          <dd className="col-7 text-right">
                            {toNumber(
                              active_other_wallets_balance,
                              maps.coin_decimals[active_other].price
                            )}{" "}
                            {active_other}
                          </dd>
                          {/* <dt className="col-5">
                            {t("差出金額")} {active_other}
                          </dt>
                          <dd className="col-7 text-right">
                            {toNumber(
                              Number(
                                (true
                                  ? active_price_global_buy
                                  : price_buy) * amount_buy
                              ),
                              maps.coin_decimals[active_other].price
                            )}{" "}
                            {active_other}
                          </dd> */}
                        </dl>
                        <div className="btn-group w-100 mt-1" role="group">
                          <button
                            type="button"
                            className="btn btn-success btn-block"
                            onClick={() => {
                              if (active_self === "XXX") return;
                              if (amount_buy == 0) {
                                dispatch_danger(t("数量を入力してください"));
                                return;
                              }

                              if (active_self === "SCC" && amount_buy.includes(".")) {
                                dispatch_danger(t("SCCは1枚単位で入力してください"));
                                return;
                              }

                              dispatch_post_markets_exchanges(
                                {
                                  symbol: active_pair,
                                  type: 1,
                                  price: true ? "market" : price_buy,
                                  trigger,
                                  amount: amount_buy,
                                },
                                () => {
                                  dispatch_info(t("買い注文しました。"));
                                }
                              );
                            }}
                          >
                            {active_self === "XXX" ? "準備中" : t("買う")} {active_self}
                          </button>
                        </div>
                        {/* </>
                        )} */}
                      </div>
                      <div className="col-md-6 order-md-2">
                        {!(active_self === "SCC" && active_other === "SCP") && (
                          <>
                            {false && (
                              <TextFieldNumber
                                fullWidth={true}
                                value={price_sell}
                                set_value={set_price_sell}
                                labelText={t("指値")}
                                endAdornment={active_other}
                                decimalScale={maps.coin_decimals[active_pair].price}
                              />
                            )}
                            <TextFieldNumber
                              fullWidth={true}
                              value={amount_sell}
                              set_value={set_amount_sell}
                              labelText={t("数量")}
                              endAdornment={active_self}
                              decimalScale={maps.coin_decimals[active_pair].amount}
                            />

                            <dl className="row small">
                              <dt className="col-5">
                                {t("利用可能")} {active_self}
                              </dt>
                              <dd className="col-7 text-right">
                                {toNumber(
                                  active_self_wallets_balance,
                                  maps.coin_decimals[active_self].price
                                )}{" "}
                                {active_self}
                              </dd>
                              {/* <dt className="col-5">
                            {t("受取金額")} {active_other}
                          </dt>
                          <dd className="col-7 text-right">
                            {toNumber(
                              Number(
                                (true
                                  ? active_price_global_sell
                                  : price_sell) * amount_sell
                              ),
                              maps.coin_decimals[active_other].price
                            )}{" "}
                            {active_other}
                          </dd> */}
                            </dl>

                            <div className="btn-group w-100 mt-1" role="group">
                              <button
                                type="button"
                                className="btn btn-danger btn-block"
                                onClick={() => {
                                  if (active_self === "XXX") return;
                                  if (amount_sell == 0) {
                                    dispatch_danger(t("数量を入力してください"));
                                    return;
                                  }

                                  if (active_self === "SCC" && amount_sell.includes(".")) {
                                    dispatch_danger(t("SCCは1枚単位で入力してください"));
                                    return;
                                  }

                                  dispatch_post_markets_exchanges(
                                    {
                                      symbol: active_pair,
                                      type: 2,
                                      price: true ? "market" : price_sell,
                                      trigger,
                                      amount: amount_sell,
                                    },
                                    () => {
                                      dispatch_info(t("売り注文しました。"));
                                    }
                                  );
                                }}
                              >
                                {active_self === "XXX" ? "準備中" : t("売る")} {active_self}
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      {reduce_get_markets_orders.askbid ? (
                        <>
                          <div className="col-12 d-block d-md-none">
                            <TableDenseAskBid
                              rows={reduce_get_markets_orders.askbid}
                              set_price={(val) => {
                                // const str = numberFixed(val);
                                const str = toNumber(val, maps.coin_decimals[active_self].price);

                                set_price_buy(str);
                                set_price_sell(str);
                              }}
                              accounts={accounts}
                              active_self={active_self}
                              active_other={active_other}
                              active_pair={active_pair}
                              active_price={active_price}
                              rate_dollar={rate_dollar}
                              rate_yen={rate_yen}
                              other_price={maps.coin_decimals[active_other].price}
                              active_rate={active_rate}
                            />
                          </div>
                        </>
                      ) : null}
                      <div className="col-md-12 order-md-1">
                        <Select
                          labelId={t("時間単位")}
                          id="demo-simple-select"
                          value={type}
                          onChange={(event) => {
                            set_type(event.target.value);
                            dispatch_get_markets_ohlcs(
                              {
                                symbol: active_pair,
                                type: event.target.value,
                                limit,
                              },
                              (data) => {}
                            );
                          }}
                        >
                          {Object.keys(maps_type).map((k) => {
                            return <MenuItem value={`${maps_type[k]}`}>{k}</MenuItem>;
                          })}
                        </Select>
                        <Select
                          labelId={t("件数")}
                          id="demo-simple-select"
                          value={limit}
                          onChange={(event) => {
                            set_limit(event.target.value);
                            dispatch_get_markets_ohlcs(
                              {
                                symbol: active_pair,
                                type,
                                limit: event.target.value,
                              },
                              (data) => {}
                            );
                          }}
                        >
                          {Object.keys(maps_limit).map((k) => {
                            return <MenuItem value={`${maps_limit[k]}`}>{k}</MenuItem>;
                          })}
                        </Select>

                        {loading ? null : (
                          <Chart
                            type={type}
                            limit={limit}
                            ohlcs={reduce_get_markets_ohlcs.ohlcs}
                            reduce_get_markets_ohlcs={reduce_get_markets_ohlcs}
                          />
                        )}
                      </div>

                      {reduce_get_markets_orders.askbid ? (
                        <>
                          <div className="col-12 d-block d-md-none">
                            <TableDense
                              loading={reduce_get_markets_orders.isLoading}
                              rows={reduce_get_markets_orders.orders}
                              set_price={(val) => {
                                const str = toNumber(val, maps.coin_decimals[active_self].price);
                                set_price_buy(str);
                                set_price_sell(str);
                              }}
                              accounts={accounts}
                              active_other={active_other}
                              active_self={active_self}
                            />
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="footer">
          <div className="container-fluid d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
            <div className="pl-3 ml-md-0">
              <small>Version 1.0.0</small>
            </div>
            <small>© SC WORLD EXCHANGE</small>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default ExchSimple;
